module.exports = __webpack_public_path__ + "img/logo.bc032c80.svg";